// Field names shown in a fee cell's pending-change author tooltip.
export const FEE_FIELD_LABEL = {
  FEE_TYPE_NAME: 'Fee',
  AMOUNT: 'Amount',
  FEE_PROVIDER_NAME: 'Fee Provider',
  TOTAL_AT_CLOSING_AMOUNT: 'Borrower-Paid · At Closing',
  TOTAL_BEFORE_CLOSING_AMOUNT: 'Borrower-Paid · Before Closing',
  BORROWER_PAID_AT_CLOSING_AMOUNT: 'Borrower-Paid · At Closing',
  BORROWER_PAID_BEFORE_CLOSING_AMOUNT: 'Borrower-Paid · Before Closing',
  SELLER_PAID_AT_CLOSING_AMOUNT: 'Seller-Paid · At Closing',
  SELLER_PAID_BEFORE_CLOSING_AMOUNT: 'Seller-Paid · Before Closing',
  PAID_BY_OTHERS_AMOUNT: 'Paid By Others',
  FINANCED_AMOUNT: 'Financed Amount',
};

export const FEE_NAME_FIELD = 'feeTypeName';

// The history fields behind the fee name cell: picking another fee type renames the fee.
export const FEE_NAME_HISTORY_FIELDS = ['feeTypeName', 'feeTypeId', 'name'];
